module.exports = __webpack_public_path__ + "3f0ee7ee03015c785a0b57096898992d.pdf";